import { Motivo } from './tipologiche/motivo';

export class Rinvio {
  id: string;
  dataDa: number;
  dataA: number;
  ora: string;
  motivo: Motivo;
  note: string;
}
